import axios from "axios";

export default {

    // Método para consultar entidades cliente
    async consultarEntidadCliente(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/consulta-entidad",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: params.nombre_entidad
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    // Método para crear/guardar un nuevo cliente
    async guardarEntidadCliente(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/guardar-entidad-verificada",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "entidad_cliente",
                id_version: "4",
                data: {
                    tipo_de_identificacion: params.tipo_de_identificacion,
                    numero_de_identificacion: params.numero_de_identificacion,
                    nombre_cliente: params.nombre_cliente,
                    tipo_cliente: params.tipo_cliente,
                    departamento: params.departamento,
                    municipio: params.municipio,
                    direccion: params.direccion,
                    celular: parseInt(params.celular),
                    correo_electronico: params.correo_electronico,
                    cantidad_de_usuarios: parseInt(params.cantidad_de_usuarios),
                    barrio: params.barrio,
                    actividad: params.actividad,
                    perfil: params.perfil
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    // Método para editar un cliente existente
    async editarEntidadCliente(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/editar-entidad-verificada",
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "entidad_cliente",
                id_version: "4",
                id_metadata: params.id_metadata,
                data: {
                    tipo_de_identificacion: params.tipo_de_identificacion,
                    numero_de_identificacion: params.numero_de_identificacion,
                    nombre_cliente: params.nombre_cliente,
                    tipo_cliente: params.tipo_cliente,
                    departamento: params.departamento,
                    municipio: params.municipio,
                    direccion: params.direccion,
                    celular: parseInt(params.celular),
                    correo_electronico: params.correo_electronico,
                    cantidad_de_usuarios: parseInt(params.cantidad_de_usuarios),
                    barrio: params.barrio,
                    actividad: params.actividad,
                    perfil: params.perfil
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    // Método para crear/guardar un nuevo proveedor
    async guardarEntidadProveedor(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/guardar-entidad-verificada",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "entidad_proveedor",
                id_version: "5",
                data: {
                    tipo_de_identificacion: params.tipo_de_identificacion,
                    numero_de_identificacion: params.numero_de_identificacion,
                    nombre_proveedor: params.nombre_proveedor,
                    tipo_proveedor: params.tipo_proveedor,
                    departamento: params.departamento,
                    municipio: params.municipio,
                    direccion: params.direccion,
                    celular: parseInt(params.celular),
                    correo_electronico: params.correo_electronico,
                    cantidad_de_usuarios: parseInt(params.cantidad_de_usuarios),
                    perfil: params.perfil
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    // Método para editar un proveedor existente
    async editarEntidadProveedor(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/" + "negocio/editar-entidad-verificada",
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: "entidad_proveedor",
                id_version: "5",
                id_metadata: params.id_metadata,
                data: {
                    tipo_de_identificacion: params.tipo_de_identificacion,
                    numero_de_identificacion: params.numero_de_identificacion,
                    nombre_proveedor: params.nombre_proveedor,
                    tipo_proveedor: params.tipo_proveedor,
                    departamento: params.departamento,
                    municipio: params.municipio,
                    direccion: params.direccion,
                    celular: parseInt(params.celular),
                    correo_electronico: params.correo_electronico,
                    cantidad_de_usuarios: parseInt(params.cantidad_de_usuarios),
                    perfil: params.perfil
                }
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            return false;
        }
    },

    async GuardarArchivosentidad (params){
        console.log("params",params);
        const config = {
            url: process.env.VUE_APP_BASE_API+"/"+ "negocio/guardar-entidad-archivos",
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              Authorization:  localStorage.getItem('userToken'),
            },
            data: params  
        };
        const response = await  axios(config);
    
    
        if(response.status == 200){
            return (await response).data;
        } else {
            return false;
        }  
    },
    async ConsultarArchivosentidadId (params){
        console.log("params",params);
        const config = {
            url: process.env.VUE_APP_BASE_API+"/"+ "negocio/consulta-entidad-archivos-id",
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              Authorization:  localStorage.getItem('userToken'),
            },
            data: params  
        };
        const response = await  axios(config);
    
    
        if(response.status == 200){
            return (await response).data;
        } else {
            return false;
        }  
    },
    async Guardarentidadpaciente (params){
        const config = {
            url: process.env.VUE_APP_BASE_API+"/"+ "negocio/guardar-entidad-verificada",
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              Authorization:  localStorage.getItem('userToken'),
            },
            data: JSON.stringify(
             {
                 nombre_entidad: params.nombre_entidad, 
                 id_version: params.id_version,
                 data:{
                    tipo_de_identificacion: params.tipo_documento,
                    numero_de_identificacion: params.documento,
                    nombre_completo: params.nombre_completo,
                    departamento: params.departamento,
                    municipio: params.municipio,
                    direccion: params.direccion,
                    barrio: params.barrio,
                    telefono_1: params.telefono_1,
                    telefono_2: params.telefono_2,
                    telefono_3: params.telefono_3,
                    cobertura: params.cobertura,
                    afiliacion: params.afiliacion,
                    nacimiento: params.nacimiento,
                    genero: params.genero,
                    nacionalidad: params.nacionalidad,
                    talla: params.talla,
                    tipo_via: params.tipo_via,
                    number: params.number,
                    number1: params.number1,
                    number2: params.number2,
                    tipo_inmueble: params.tipo_inmueble,
                    number3: params.number3,
                    bloque: params.bloque,
                    number4: params.number4,
                    eps: params.eps,
                    nombre_contacto: params.nombre_contacto,
                    email: params.email,
                    observacion_contacto: params.observacion_contacto,
                 }
             }),   
        };
        const response = await  axios(config);
    
    
        if(response.status == 200){
            return (await response).data;
        } else {
            return false;
        }  
    },

    async Guardarentidad(params) {

        console.log("params",params);
         const config = {
           url: process.env.VUE_APP_BASE_API+"/"+ "negocio/guardar-entidad-verificada",
           method: 'POST',
           headers: {
             'Content-Type': 'application/json',
             'Accept': 'application/json',
             Authorization:  localStorage.getItem('userToken'),
           },
           data: JSON.stringify(
            {
                nombre_entidad: params.nombre_entidad, 
                id_version: params.id_version,
                data:{
                    tipo_documento: parseInt(params.tipo_documento) || 0,
                   documento: parseInt(params.documento) || 0,
                   nombre_completo:params.nombre_completo,
                   edad: parseInt(params.edad) || 0,
                   departamento: params.departamento,
                   municipio:params.municipio,
                   direccion:params.direccion,
                   barrio:params.barrio,
                   telefono_1: parseInt(params.telefono_1) || 0,
                   telefono_2: parseInt(params.telefono_2) || 0,
                   telefono_3: parseInt(params.telefono_3) || 0,
                   cobertura: parseInt(params.cobertura) || 0,
                   afiliacion: parseInt(params.afiliacion) || 0,
                   elementos:params.elementos || [],
                   elementos_institucion:params.elementos_institucion || [],
                   elementos_homologacion:params.elementos_homologacion || [],
                   elementos_institucion_homologacion:params.elementos_institucion_homologacion || [],
                   dosis: params.dosis,
                   hora_dosis: params.hora_dosis,
                   lugar_entrega:params.lugar_entrega,
                   nombre_institucion:params.nombre_institucion,
                   direccion_entrega:params.direccion_entrega,
                   detalle_entrega:params.detalle_entrega,
                   medio_administracion:params.medio_administracion,
                   horas_consumo_dia:params.horas_consumo_dia,
                   diagnostico:params.diagnostico,
                   cie_10_diagnostico:params.cie_10_diagnostico,
                   tiempo_revision_medica:params.tiempo_revision_medica,
                   estado:params.estado,
                   observaciones:params.observacion,
                   id_proveedor:params.id_proveedor,
                   id_cliente:params.id_cliente,
                //    fecha_valoracion:params.fecha_valoracion,
                   id_paciente:params.id_paciente,
                   nacimiento: params.nacimiento,
                    genero: parseInt(params.genero) || 0,
                    nacionalidad: params.nacionalidad,
                    talla: parseFloat(params.talla) || 0,
                    tipo_via: parseInt(params.tipo_via) || 0,
                    number: params.number != null ? params.number : '',
                    number1: params.number1 != null ? params.number1 : '',
                    number2: params.number2 != null ? params.number2 : '',
                    tipo_inmueble: parseInt(params.tipo_inmueble) || 0,
                    number3: params.number3 != null ? params.number3 : '',
                    bloque: parseInt(params.bloque) || 0,
                    number4: params.number4 != null ? params.number4 : '',
                    eps: parseInt(params.eps) || 0,
                    nombre_contacto: params.nombre_contacto,
                    email: params.email,
                    observacion_contacto: params.observacion_contacto,
                    tipo_mascara: parseInt(params.tipo_mascara) || 0,
                    lugarEntrega: params.lugarEntrega,
                    nombreInstitucion: params.nombreInstitucion,
                    doctor: params.doctor,
                      tipo_documento_medico: params.tipo_documento_medico,
                numero_documento_medico: params.numero_documento_medico,
                email_institucion: params.email_institucion,
                    documento_adjunto: params.documento_adjunto,
                     tipo_paciente: params.tipo_paciente,
                     nivel_ingreso: params.nivel_ingreso || '',
                     ips_paciente: params.ips_paciente || '',
                }
            }),   
       };
       const response = await  axios(config);
   
   
       if(response.status == 200){
           return (await response).data;
       } else {
           return false;
       }  
      
       },mantenerFormatoDecimal(numeroComoTexto) {
        let numero = parseFloat(numeroComoTexto);
        let resultado = Number.isInteger(numero) ? `${numero}.01` : numeroComoTexto;
        console.log("resultadikkkkkkkk",resultado);
        return  resultado
        
    },
       async getSolicitudes(params){

        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-meta-data-entidad?nombreEntidad="+params.nombreEntidad+"&idVersion="+params.idVersion+"&size="+params.size+"&page="+params.page+"&orderBy="+params.orderBy+"&typeOrder="+params.typeOrder+"&filterByColum="+params.filterByColum+"&filter="+params.filter+"&dateBy="+params.dateBy+"&startDate="+params.startDate+"&endDate="+params.endDate,
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization:  localStorage.getItem('userToken'),
               
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }
        
    },
    async editarentidadpaciente(params){
        
        const config = {
          url: process.env.VUE_APP_BASE_API+"/"+ "negocio/editar-entidad-verificada",
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            Authorization:  localStorage.getItem('userToken'),
          },
          data: JSON.stringify(
           {
               nombre_entidad: params.nombre_entidad, 
               id_version: params.id_version,
               id_metadata:params.id_metadata,
               data:{
                tipo_de_identificacion: params.tipo_documento,
                numero_de_identificacion: params.documento,
                nombre_completo: params.nombre_completo,
                departamento: params.departamento,
                municipio: params.municipio,
                direccion: params.direccion,
                barrio: params.barrio,
                telefono_1: params.telefono_1,
                telefono_2: params.telefono_2,
                telefono_3: params.telefono_3,
                cobertura: params.cobertura,
                afiliacion: params.afiliacion,
                nacimiento: params.nacimiento,
                genero: params.genero,
                nacionalidad: params.nacionalidad,
                talla: params.talla,
                tipo_via: params.tipo_via,
                number: params.number,
                number1: params.number1,
                number2: params.number2,
                tipo_inmueble: params.tipo_inmueble,
                number3: params.number3,
                bloque: params.bloque,
                number4: params.number4,
                eps: params.eps,
                nombre_contacto: params.nombre_contacto,
                email: params.email,
                observacion_contacto: params.observacion_contacto,
               }
           }), 
        };
        const response = await  axios(config);
    
    
        if(response.status == 200){
            return (await response).data;
        } else {
            return false;
        }  
       
    },
    // Edición administrativa: solo envía los campos explícitamente incluidos en params.data
    async editarCamposAdministrativos(params) {
        const config = {
          url: process.env.VUE_APP_BASE_API + "/negocio/editar-entidad-verificada",
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            Authorization: localStorage.getItem('userToken'),
          },
          data: JSON.stringify({
            nombre_entidad: params.nombre_entidad,
            id_version: params.id_version,
            id_metadata: params.id_metadata,
            data: params.data,  // el objeto data viene armado desde el componente, sin defaults
          }),
        };
        const response = await axios(config);
        if (response.status == 200) {
            return response.data;
        } else {
            return false;
        }
    },
    async editarentidadsolicitud(params) {
        console.log("params --->",params);
        const config = {
          url: process.env.VUE_APP_BASE_API+"/"+ "negocio/editar-entidad-verificada",
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            Authorization:  localStorage.getItem('userToken'),
          },
          data: JSON.stringify(
           {
               nombre_entidad: params.nombre_entidad, 
               id_version: params.id_version,
               id_metadata:params.id_metadata,
               data:{
                   tipo_documento:params.tipo_documento,
                   documento:params.documento,
                   nombre_completo:params.nombre_completo,
                   edad:params.edad,
                   departamento: params.departamento,
                   municipio:params.municipio,
                   direccion:params.direccion,
                   barrio:params.barrio,
                   telefono_1:params.telefono_1,
                   telefono_2:params.telefono_2,
                   telefono_3:params.telefono_3,
                   cobertura:params.cobertura,
                   afiliacion:params.afiliacion,
                   elementos:params.elementos || [],
                   elementos_institucion:params.elementos_institucion || [],
                   elementos_homologacion:params.elementos_homologacion || [],
                   elementos_institucion_homologacion:params.elementos_institucion_homologacion || [],
                   dosis: params.dosis,
                   hora_dosis: params.hora_dosis,
                   lugar_entrega:params.lugar_entrega,
                   nombre_institucion:params.nombre_institucion,
                   direccion_entrega:params.direccion_entrega,
                   detalle_entrega:params.detalle_entrega,
                   medio_administracion:params.medio_administracion,
                   horas_consumo_dia:params.horas_consumo_dia,
                   diagnostico:params.diagnostico,
                   cie_10_diagnostico:params.cie_10_diagnostico,
                   tiempo_revision_medica:params.tiempo_revision_medica,
                   estado:params.estado,
                   observaciones:params.observacion,
                   id_proveedor:params.id_proveedor,
                   id_cliente:params.id_cliente,
                   fecha_valoracion:params.fecha_valoracion,
                   id_paciente:params.id_paciente,
                   nacimiento: params.nacimiento,
                    genero: params.genero,
                    nacionalidad: params.nacionalidad,
                    talla: params.talla,
                    tipo_via: params.tipo_via,
                    number: params.number,
                    number1: params.number1,
                    number2: params.number2,
                    tipo_inmueble: params.tipo_inmueble,
                    number3: params.number3,
                    bloque: params.bloque,
                    number4: params.number4,
                    eps: params.eps,
                    nombre_contacto: params.nombre_contacto,
                    email: params.email,
                    observacion_contacto: params.observacion_contacto,
                    tipo_mascara: params.tipo_mascara,
                    lugarEntrega: params.lugarEntrega,
                    nombreInstitucion: params.nombreInstitucion,
                    doctor: params.doctor,
                    documento_adjunto: params.documento_adjunto,
                    tipo_documento_medico: params.tipo_documento_medico,
                numero_documento_medico: params.numero_documento_medico,
                email_institucion: params.email_institucion,
                tipo_paciente: params.tipo_paciente,
                nivel_ingreso: params.nivel_ingreso || '',
                ips_paciente: params.ips_paciente || '',
               }
           }),   
      };
      const response = await  axios(config);
  
  
      if(response.status == 200){
          return (await response).data;
      } else {
          return false;
      }  
     
      },
      async getSolicitudes(params){

       const config = {
           url: process.env.VUE_APP_BASE_API + "/negocio/get-meta-data-entidad?nombreEntidad="+params.nombreEntidad+"&idVersion="+params.idVersion+"&size="+params.size+"&page="+params.page+"&orderBy="+params.orderBy+"&typeOrder="+params.typeOrder+"&filterByColum="+params.filterByColum+"&filter="+params.filter+"&dateBy="+params.dateBy+"&startDate="+params.startDate+"&endDate="+params.endDate,
           method: 'GET',
           headers: {
               'Content-Type': 'application/json',
               'Accept': 'application/json',
               Authorization:  localStorage.getItem('userToken'),
              
           },
       };
       const response = await axios(config);

       if (response.status == 200) {
           return (await response).data;
       } else  {
           throw new Error(response.status);
       }
       
   },
   async bloquearSolicitud(id_solicitud) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/bloquear-solicitud",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({ id_solicitud }),
        };
        const response = await axios(config);
        return response.data;
    },

    async desbloquearSolicitud(id_solicitud) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/desbloquear-solicitud",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({ id_solicitud }),
        };
        const response = await axios(config);
        return response.data;
    },

    async verificarBloqueos(ids) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/verificar-bloqueos",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({ ids }),
        };
        const response = await axios(config);
        return response.data;
    },

   async  putEstadosSolicitudes(params){
        const sanitizeObs = (val) => (typeof val === 'string' ? val.replace(/\//g, '-').replace(/'/g, '\u2019').replace(/\\/g, '-') : val);

        // Acumular observaciones principales con el historial existente
        // let observacionesAcumuladas = params.observaciones;
        // if (params.observaciones) {
        //     try {
        //         const currentData = await this.consultaEntidadById({
        //             nombre_entidad: params.nombre_entidad,
        //             id_metadata: params.id_metadata
        //         });
        //         if (currentData && currentData.length > 0 && currentData[0].data && currentData[0].data.observaciones) {
        //             const now = new Date();
        //             const fecha = `${now.getDate().toString().padStart(2,'0')}/${(now.getMonth()+1).toString().padStart(2,'0')}/${now.getFullYear()} ${now.getHours().toString().padStart(2,'0')}:${now.getMinutes().toString().padStart(2,'0')}`;
        //             observacionesAcumuladas = `[${fecha}] ${params.observaciones}\n${currentData[0].data.observaciones}`;
        //         }
        //     } catch (e) {
        //         // Si falla la consulta previa, continuar con la observación nueva sin acumular
        //     }
        // }

        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/editar-entidad-verificada-por-metadata-especifica",
            method: 'PUT',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json',
              Authorization:  localStorage.getItem('userToken'),
            },
            data: JSON.stringify(
             {
                nombre_entidad: params.nombre_entidad,
                id_metadata: params.id_metadata,
                id_version: params.id_version,
                data: {
                    estado:params.estado,
                    id_proveedor:params.id_proveedor,
                    motivo_rechazo:params.motivo_rechazo,
                    otro_motivo:params.otro_motivo,
                    fecha_asignada:params.fecha_asignada,
                    id_cliente:params.id_cliente,
                    fecha_valoracion:params.fecha_valoracion,
                    fecha_retiro_oxigeno:params.fecha_retiro_oxigeno,
                    fecha_retiro_efectivo:params.fecha_retiro_efectivo,
                    fecha_proceso_retiro:params.fecha_proceso_retiro,
                    fecha_retiro_fallido:params.fecha_retiro_fallido,
                    fecha_entrega_elementos:params.fecha_entrega_elementos,
                    id_paciente:params.id_paciente,
                    id_prestador:params.id_prestador,
                    fecha_asignacion:params.fecha_asignacion,
                    observaciones:sanitizeObs(params.observaciones),
                    // Campos específicos por actor - Cancelación (Institución)
                    motivo_cancelacion_institucion:params.motivo_cancelacion_institucion != null ? params.motivo_cancelacion_institucion : 0,
                    detalle_cancelacion_institucion:params.detalle_cancelacion_institucion,
                    observaciones_cancelacion_institucion:sanitizeObs(params.observaciones_cancelacion_institucion),
                    // Campos específicos por actor - Rechazo (Prestador)
                    motivo_rechazo_prestador:params.motivo_rechazo_prestador,
                    detalle_rechazo_prestador:params.detalle_rechazo_prestador,
                    observaciones_rechazo_prestador:sanitizeObs(params.observaciones_rechazo_prestador),
                    // Campos específicos por actor - Devolución (Proveedor)
                    motivo_devolucion_proveedor:params.motivo_devolucion_proveedor,
                    detalle_devolucion_proveedor:params.detalle_devolucion_proveedor,
                    observaciones_devolucion_proveedor:sanitizeObs(params.observaciones_devolucion_proveedor),
                    // Elementos seleccionados para retiro
                    elementos_retiro:params.elementos_retiro,
                    // Elementos ya retirados (acumulado histórico de IDs)
                    elementos_retirados:params.elementos_retirados}
             }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }
   },
    async getSolicitudesxId(params){


        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/get-meta-data-entidad-id?nombreEntidad=entidad_solicitud&metadataId=1&idVersion=2",
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization:  localStorage.getItem('userToken'),
               
            },
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else  {
            throw new Error(response.status);
        }
        
    },

    // Método para consultar una entidad por su ID
    async consultaEntidadById(params) {
        const config = {
            url: process.env.VUE_APP_BASE_API + "/negocio/consulta-entidad-id",
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
                Authorization: localStorage.getItem('userToken'),
            },
            data: JSON.stringify({
                nombre_entidad: params.nombre_entidad,
                id: params.id_metadata
            }),
        };
        const response = await axios(config);

        if (response.status == 200) {
            return (await response).data;
        } else {
            throw new Error(response.status);
        }
    },

    // Método para dividir una solicitud en múltiples solicitudes
    async dividirSolicitud(params) {
        try {
            const config = {
                url: process.env.VUE_APP_BASE_API + "/negocio/dividir-solicitud",
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    Authorization: localStorage.getItem('userToken'),
                },
                data: JSON.stringify({
                    id_solicitud: params.id_solicitud,
                    divisiones: params.divisiones
                }),
            };
            const response = await axios(config);

            if (response.status == 200) {
                return response.data;
            } else {
                throw new Error(response.status);
            }
        } catch (error) {
            // Si el backend devuelve un error (400, 403, 404, 500, etc.)
            if (error.response && error.response.data && error.response.data.error) {
                // Devolver el error formateado del backend
                return {
                    error: {
                        message: error.response.data.error.message,
                        status: error.response.data.error.status
                    }
                };
            }
            // Error genérico si no viene del backend
            throw error;
        }
    }
};